<template>
	<div>
		<div class='knd-story' v-if="content">	
			<Percentage />

			<div class="kop-wrap">
				<h1><span>{{ content.kop.tekst }}</span></h1>
			</div>

			<div class="text-wrap">
				
				
				<Introchat class="introchat" :gesprek="content.chat_0_1" />

				<!-- <h1><span>{{ content.kop.tekst }}</span></h1> -->
			</div>

			<kinesis-container 
				class="bg_message_container"
				:event='"scroll"' 
				:duration="1" >
				<kinesis-element :strength="500" class="bg_message_wrap">
					<div
						class="bg_message"
						:style='"top:0px;left:" + getHeaderMessagePos(.5) + "px;"'>
						<p>Kech, ik hoorde dat je makkelijk was</p>
					</div>
				</kinesis-element>
				<kinesis-element :strength="600" class="bg_message_wrap">
					<div
						class="bg_message"
						:style='"top:120px;left:" + getHeaderMessagePos(.75) + "px;"'>
						<p>Wat is je snap? Heb je nog meer foto’s?</p>
					</div>
				</kinesis-element>
				<kinesis-element :strength="200" class="bg_message_wrap">
					<div
						class="bg_message"
						:style='"top:300px;left:" + getHeaderMessagePos(.05) + "px;"'>
							<p>He schatje, zin in een romantische date?</p>
					</div>
				</kinesis-element>
				<kinesis-element :strength="100" class="bg_message_wrap">
					<div
						class="bg_message"
						:style='"top:350px;left:" + getHeaderMessagePos(.5) + "px;"'>
						<p>Zal ik vanavond anders langskomen?</p>
					</div>
				</kinesis-element>
				<kinesis-element :strength="300" class="bg_message_wrap">
					<div
						class="bg_message"
						:style='"top:250px;left:" + getHeaderMessagePos(.25) + "px;"'>
						<img class="emoticon" :src="require('@/assets/images/icons/icon_8.png')" alt="" />
						<img class="emoticon" :src="require('@/assets/images/icons/icon_8.png')" alt="" />
						<img class="emoticon" :src="require('@/assets/images/icons/icon_8.png')" alt="" />
					</div>
				</kinesis-element>
			</kinesis-container>

			<div class="text-wrap">
				<p class="text introtext" v-html="content.intro.tekst"></p>

				<p class="text" v-html="content.paragraaf_0_1.tekst"></p>
			</div>

			<div class="strooigoed-wrapper">
				<img class="strooigoed" :src="getStrooigoed(require('@/assets/images/strooigoed_1.png'), require('@/assets/images/strooigoed_1-M.png'))" alt="" />
			</div>

			<div class="text-wrap">
				<h3>{{ content.hoofdstuk_1.kop }}</h3>

				<p class="text" v-html="content.paragraaf_1_1.tekst"></p>

				<img class="strooigoed" :src="require('@/assets/images/shayla.png')" alt="" />

				<p class="text" v-html="content.paragraaf_1_2.tekst"></p>

				<Message :gesprek="content.chat_1_1" />

				<p class="text" v-html="content.paragraaf_1_3.tekst"></p>

				<Message :gesprek="content.chat_1_2" />

				<p class="text" v-html="content.paragraaf_1_4.tekst"></p>

				<Message :gesprek="content.chat_1_3" />

				<p class="text" v-html="content.paragraaf_1_5.tekst"></p>
			</div>

			<div class="strooigoed-wrapper">
				<img class="strooigoed" :src="getStrooigoed(require('@/assets/images/strooigoed_anna_studio.png'), require('@/assets/images/strooigoed_anna_studio-M.png'))" alt="" />
			</div>

			<div class="text-wrap">
				<h3>{{ content.hoofdstuk_2.kop }}</h3>

				<p class="text" v-html="content.paragraaf_2_1.tekst"></p>
			</div>

			<div class="video-wrapper">
				<img class="video-bg" :src="require('@/assets/images/bg_video.png')" alt="" />
				<video class="video" controls="controls" :poster="require('@/assets/video/wippen_placeholder.png')">
					<source 
						:src='require("@/assets/video/wippen.mp4")'
						type="video/mp4" />
					<img :src="require('@/assets/video/wippen_placeholder.png')" />
					Uw browser ondersteunt het element <code>video</code> niet.
				</video>
			</div>
			

			<div class="text-wrap">
				<p class="text" v-html="content.paragraaf_2_2.tekst"></p>

				<Chat :gesprek="content.chat_2_1" />

				<p class="text" v-html="content.paragraaf_2_3.tekst"></p>
			</div>

			<div class="tekstvak">
				<div class="text-wrap">
					<h3>{{ content.hoofdstuk_3.kop }}</h3>

					<p class="text" v-html="content.paragraaf_3_1.tekst"></p>

					<iframe src='https://flo.uri.sh/visualisation/7462986/embed' title='Interactive or visual content' class='flourish-embed-iframe' frameborder='0' scrolling='no' style='width:100%;height:600px;' sandbox='allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'></iframe>

					<p class="text" v-html="content.paragraaf_3_2.tekst"></p>
				</div>
			</div>

			<div class="text-wrap">
				<h3>{{ content.hoofdstuk_4.kop }}</h3>

				<p class="text" v-html="content.paragraaf_4_1.tekst"></p>

				<Chat :gesprek="content.chat_4_1" />

				<p class="text" v-html="content.paragraaf_4_2.tekst"></p>

				<Chat :gesprek="content.chat_4_2" />

				<p class="text" v-html="content.paragraaf_4_3.tekst"></p>

				<Chat :gesprek="content.chat_4_3" />

				<p class="text" v-html="content.paragraaf_4_4.tekst"></p>

				<Chat :gesprek="content.chat_4_4" />

				<p class="text" v-html="content.paragraaf_4_5.tekst"></p>
			</div>

			<div class="tekstvak">
				<div class="text-wrap">
					<h3>{{ content.hoofdstuk_5.kop }}</h3>

					<p class="text" v-html="content.paragraaf_5_1.tekst"></p>

					<iframe src='https://flo.uri.sh/visualisation/7466892/embed' title='Interactive or visual content' class='flourish-embed-iframe' frameborder='0' scrolling='no' style='width:100%;height:600px;' sandbox='allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'></iframe>

					<p class="text" v-html="content.paragraaf_5_2.tekst"></p>
				</div>
			</div>

			<div class="text-wrap">
				<h3>{{ content.hoofdstuk_6.kop }}</h3>

				<p class="text" v-html="content.paragraaf_6_1.tekst"></p>

				<Chat :gesprek="content.chat_6_1" />

				<p class="text" v-html="content.paragraaf_6_2.tekst"></p>
			</div>

			<div class="strooigoed-wrapper">
				<img class="strooigoed" :src="getStrooigoed(require('@/assets/images/strooigoed_telefoon.png'), require('@/assets/images/strooigoed_telefoon-M.png'))"	alt="" />
			</div>

			<div class="text-wrap">
				<p class="text" v-html="content.paragraaf_6_3.tekst"></p>
			</div>

			<div class="tekstvak">
				<div class="text-wrap">
					<p class="text" v-html="content.paragraaf_6_4.tekst"></p>

					<iframe src='https://flo.uri.sh/visualisation/7466103/embed' title='Interactive or visual content' class='flourish-embed-iframe' frameborder='0' scrolling='no' style='width:100%;height:600px;' sandbox='allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'></iframe>

					<p class="text" v-html="content.paragraaf_6_5.tekst"></p>
				</div>
			</div>

			<div class="text-wrap">
				<h3>{{ content.hoofdstuk_7.kop }}</h3>

				<p class="text" v-html="content.paragraaf_7_1.tekst"></p>
			</div>

			<div class="strooigoed-wrapper">
				<img class="strooigoed" :src="getStrooigoed(require('@/assets/images/strooigoed_anna_belt_terug.png'), require('@/assets/images/strooigoed_anna_belt_terug-M.png'))" alt="" />
			</div>

			<div class="text-wrap">
				<p class="text" v-html="content.paragraaf_7_2.tekst"></p>

				<h3>{{ content.hoofdstuk_8.kop }}</h3>

				<p class="text" v-html="content.paragraaf_8_1.tekst"></p>
			</div>

			<div class="portretten-container">
				<div 
					v-for="(portret, index) in content.portretjes"
					:key="'portret' + index"
					class="portret"
					:style="'margin-top:' + getPortretPos(index) + 'px;'">

					<div class="portret-wrap">
						<img 
							:src="require('@/assets/images/portretten/' + portret.foto)"
							alt="" />

						<div class="portret-citaat">
							<p>{{ portret.naam }}</p>
							<p v-html="portret.citaat"></p>
						</div>
					</div>

				</div>
			</div>

			<div class="text-wrap">
				<div class="call-to-action">
					<p v-html="content.call_to_action.tekst"></p>
				</div>
			</div>

			<div class="tekstvak colofon">
				<div class="text-wrap">
					<h1>Colofon</h1>
					<p v-html="content.colofon.tekst"></p>
				</div>
			</div>
		</div>

		<RandomIcons :aantal="20" />
	</div>
</template>

<script>
	import RandomIcons from '../randomicons';
	import Chat from '../chat';	
	import Introchat from '../introchat';	
	import Message from '../message';
	import Percentage from '../percentage';

	export default {
		components: {
			RandomIcons,
			Chat,
			Introchat,
			Message,
			Percentage
		},
		props: [
			'content'
		],
		name: 'Story',
		data() {
			return {
				
			};
		},
		mounted() {
			console.log("content: ", this.content);
		},
		methods: {
			getPortretPos(index) {
				if (index%2 == 0 || window.innerWidth < 764) {
					return 10;
				}
				else {
					return 200;
				}
			},
			getHeaderMessagePos(number) {
				const x = window.innerWidth * number;
				return x > window.innerWidth - 350 ? 10 : x;
			},
			getStrooigoed(desktop, mobiel) {
				if (window.innerWidth > 650) {
					return desktop;
				}
				else {
					return mobiel;
				}
			}
		}
	}
</script>